import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover, Tooltip as BootstrapTooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { formatDate } from 'helpers/formatters/date_time_formats';
import Tooltip from 'components/tooltip';
import './lease_expiration_reminder_form.scss';
import { range } from 'lodash';

export default class LeaseExpirationReminderForm extends React.Component {
  static propTypes = {
    dark: PropTypes.bool,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.string,
    features: PropTypes.object,
    isAssignment: PropTypes.bool,
    readOnly: PropTypes.bool,
    renewalReminder: PropTypes.shape({
      dueDate: PropTypes.string,
      expirationCount: PropTypes.number,
      expirationUnit: PropTypes.string,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
  }

  componentDidUpdate({ disabled }) {
    if (!disabled && this.props.disabled) {
      this.props.onChange({
        renewalReminder: {
          ...this.props.renewalReminder,
          expirationCount: null,
          expirationUnit: null
        }
      });
    }
  }

  handleSendExpirationReminderChange = (event) => {
    const { checked } = event.target;
    const { expirationCount, expirationUnit } = this.props.renewalReminder;

    this.props.onChange({
      renewalReminder: {
        ...this.props.renewalReminder,
        expirationCount: checked ? (expirationCount || 1) : null,
        expirationUnit: checked ? (expirationUnit || 'months') : null
      }
    });
  }

  handleExpirationSettingsChange = (event) => {
    const { name, value } = event.target;

    this.props.onChange({
      renewalReminder: {
        ...this.props.renewalReminder,
        [name]: name === 'expirationCount' ? parseInt(value) : value
      }
    });
  }

  render() {
    const { dark, disabled, disabledTooltip, readOnly } = this.props;
    const TooltipComponent = dark ? BootstrapTooltip : Popover;

    return (
      <div className="form-group lease-expiration-reminder">
        <div className="info-reminder">
          <div>
            {((disabled || readOnly) && disabledTooltip) ? (
              <OverlayTrigger
                id="lease-expiration-invalid"
                overlay={<TooltipComponent id="lease-expiration-invalid-tooltip">{disabledTooltip}</TooltipComponent>}
                placement="right"
              >
                <div style={{ cursor: 'not-allowed' }}>{this.renderReminderCheckbox()}</div>
              </OverlayTrigger>
            ) : this.renderReminderCheckbox()}
          </div>
          <label className="label-reminder">
            Get reminded when this lease is about to expire?
          </label>
          {this.renderInfoIncon()}
        </div>
        {this.renderExpirationReminderSettings()}
      </div>
    );
  }

  renderInfoIncon = () => {
    const { features = {}, isAssignment } = this.props;
    const typeLabel = isAssignment ? 'assignment' : 'listing';
    const tooltip = features.crm
      ? `Enabling this setting creates a new task with you as the assignee.
        On the specified date, an email reminder will be sent to the assignee,
        all users on the ${typeLabel}, and your office managers.`
      : `On the specified date, an email reminder will be sent to you,
        all users on the ${typeLabel}, and your office managers.`;

    return (
      <Tooltip
        content={tooltip}
        dark
        key="reminder-tooltip"
        placement="top"
      >
        <FontAwesomeIcon className="info-icon" icon={faInfoCircle}/>
      </Tooltip>
    );
  }

  renderReminderCheckbox() {
    const { expirationCount, expirationUnit } = this.props.renewalReminder;
    const disabled = this.props.disabled || this.props.readOnly;

    return (
      <input
        checked={!!(expirationCount && expirationUnit)}
        className="mx-0"
        disabled={disabled}
        name="sendExpirationReminder"
        style={{ pointerEvents: disabled ? 'none' : 'all' }}
        type="checkbox"
        onChange={this.handleSendExpirationReminderChange}
      />
    );
  }

  renderExpirationReminderSettings() {
    const { expirationCount, expirationUnit } = this.props.renewalReminder;
    const disabled = this.props.readOnly;

    if (expirationCount && expirationUnit) {
      return (
        <div className="expiration-options">
          <div className="col-xs-12 mx-2">
            <span className="right-buffer-sm">Set a reminder</span>
            <select
              className="borderless disable-outline minimal-select"
              disabled={disabled}
              name="expirationCount"
              value={expirationCount}
              onChange={this.handleExpirationSettingsChange}
            >
              {range(1, 31).map(value => <option key={value} value={value}>{value}</option>)}
            </select>

            <select
              className="borderless disable-outline minimal-select"
              disabled={disabled}
              name="expirationUnit"
              value={expirationUnit}
              onChange={this.handleExpirationSettingsChange}
            >
              <option value="months">Months</option>
              <option value="years">Years</option>
            </select>
            <span className="right-buffer-md">before the lease expires. ({
              formatDate(this.calculateReminderDate(expirationCount, expirationUnit))
            })</span>
          </div>
        </div>
      );
    }
  }

  calculateReminderDate(count, units) {
    const parsedDate = moment(this.props.renewalReminder.dueDate);
    parsedDate.subtract(count, units);
    return parsedDate;
  }
}
